import { QContentActivityLogList } from '@exam-management/qcontent-activity-log-list';
import { SingleQuestionHeader } from '@exam-management/qcontent-detail';
import { useSaveQuestionFormSubmission } from '@exam-management/qcontent-management';
import { useParams } from '@exam-management/router';
import { Box } from '@shared/components';
import { Form } from 'react-hook-form';

export default function SingleQuestionActivityLogPage() {
  const { structureId, contentId } = useParams(
    '/qbank-structures/:structureId/qcontents/single/:contentId',
  );
  const { handleSubmit } = useSaveQuestionFormSubmission({ contentId });

  return (
    <Form>
      <SingleQuestionHeader handleSave={handleSubmit} structureId={structureId} />
      <Box sx={{ p: (theme) => theme.spacing(6) }}>
        <QContentActivityLogList questionId={contentId} />
      </Box>
    </Form>
  );
}
